
const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

const monthsInPortguese = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
];


export function getMonthNumber (monthName) {
    const monthIndex = months.findIndex(
        (month) => month.toLowerCase() === monthName.toLowerCase()
    );

    // If found, return the month number with leading zero if needed
    return monthIndex !== -1 ? String(monthIndex + 1).padStart(2, "0") : null;
}

export function getMonthName  (monthNumber)  {
    let month = parseInt(monthNumber);

    if (month < 1 || month > 12) {
        return "Número do mês inválido";
    }

    return months[month - 1];
}

export function getMonthNameInPortguese  (monthNumber)  {
    let month = parseInt(monthNumber);

    if (month < 1 || month > 12) {
        return "Número do mês inválido";
    }

    return monthsInPortguese[month - 1];
}

export function isSameMonthAndYear (monthYear) {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0");

    // Extract year and month from the given date
    const [givenYear, givenMonth] = monthYear.split("-");

    return(currentYear === parseInt(givenYear) && currentMonth === givenMonth)
}

export function getCurrencyNameByCode(currencyCode) {
    const currencyNames = {
        JPY: "Iene Japonês",
        AOA: "Kwanza Angolano",
        USD: "Dólar Americano",
        EUR: "Euro"
    };
    return currencyNames[currencyCode] || "Código de moeda inválido";
}

export function formatNumberToInternational(number, locale = "en-US") {
    if (number === 0) {
        return '';
    }
    if (typeof number === 'number' && !isNaN(number)) {
        const formatter = new Intl.NumberFormat(locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        return formatter.format(number);
    }
    return number;
}

export function formatNumberConsiderZero(number, locale = "en-US") {
    if(number === 0 || number === 0.00) return '0.00';
    return formatNumberToInternational(number)
}

// Function to get min and max dates based on addPreviousMonthRecord
export function getDateRange(addPreviousMonthRecord) {
    const today = new Date();
    const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    if (addPreviousMonthRecord) {
        // Allow records for the previous month and current month
        const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

        return {
            minDate: formatDate(firstDayOfLastMonth),
            maxDate: formatDate(lastDayOfCurrentMonth),
        };
    } else {
        // Restrict to current month only
        return {
            minDate: formatDate(firstDayOfCurrentMonth),
            maxDate: formatDate(lastDayOfCurrentMonth),
        };
    }
}

// Helper function to format date as YYYY-MM-DD
const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
